import React, { ReactNode } from 'react';
import SearchInput from './SearchInput';
import styles from './ListPageHeader.module.css';

interface ListPageHeaderProps {
  icon: ReactNode;
  title: string;
  count: number;
  // Omit both to render a header without a search box (read-only lists with no server-side search)
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  actions?: ReactNode;
  additionalContent?: ReactNode; // For special cases like selection buttons
  footer?: ReactNode; // Full-width content inside the card, below the title row
}

const ListPageHeader: React.FC<ListPageHeaderProps> = ({
  icon,
  title,
  count,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  actions,
  additionalContent,
  footer
}) => {
  return (
    <div className={styles.listPageHeader} data-test-id="list-page-header">
      <div className={styles.listPageHeaderContent}>
        <div className={styles.listPageHeaderTitleSection}>
          <h1 className={styles.listPageHeaderTitle}>
            {icon}
            {title}
            <span className={styles.listPageHeaderCount}>{count}</span>
          </h1>

          {additionalContent && <div className={styles.listPageHeaderAdditional}>{additionalContent}</div>}
        </div>

        <div className={styles.listPageHeaderActions}>
          {actions}

          {onSearchChange && (
            <SearchInput
              value={searchValue ?? ''}
              onChange={onSearchChange}
              placeholder={searchPlaceholder}
              className={styles.listPageHeaderSearch}
            />
          )}
        </div>
      </div>

      {footer && <div className={styles.listPageHeaderFooter}>{footer}</div>}
    </div>
  );
};

export default ListPageHeader;
